import { PropsValueItem } from "../../../../../../dto/FilterDto"
import VilgramFileDto from "../../../../../../dto/VilagramFileDto"

export enum ActionType {
    FILTER_IS_OPEN = 'FILTER_IS_OPEN',
    FILTER_TYPE_SELECTED = 'FILTER_TYPE_SELECTED',
    FILTER_TAGS_CHANGED = 'FILTER_TAGS_CHANGED',
    FILTER_ADDRESS_CHANGED = 'FILTER_ADDRESS_CHANGED',
    FILTER_PROPS_CHANGED = 'FILTER_PROPS_CHANGED',
    FILTER_RESET = 'FILTER_RESET'

}

export interface ActionFilter {
    type: ActionType.FILTER_IS_OPEN,
    isOpen : boolean
}
export interface ActionTypeSelected {
    type: ActionType.FILTER_IS_OPEN,
    id : number
}

export interface ActionPropsChanged {
    type: ActionType.FILTER_PROPS_CHANGED,
    id : number,
    value : any | undefined,
    from : boolean
}

export interface ActionAddressChanged {
    type: ActionType.FILTER_ADDRESS_CHANGED,
    text : string
}
export interface ActionTags {
    type: ActionType.FILTER_TAGS_CHANGED,
    ids : number[]
}
type Action = ActionFilter | ActionTypeSelected | ActionTags | ActionAddressChanged | ActionPropsChanged

export default Action